/*
  Order limit message (24 Oct 2026). Minmaxify enforces per-order limits on this theme by quietly
  lowering the quantity of an add (7 Real Salt jars becomes 6) without telling the shopper.
  When an add-to-cart button is pressed, this notes the variant and the quantity chosen in that form,
  waits for the add (and Minmaxify) to finish, and if the cart grew by less than was asked for, shows
  a short message in the top layer, above the cart drawer and quick-add dialogs.
  Loaded on every page from snippets/lytes-head.liquid.
*/
(() => {
  if (window.lytesLimits) return;
  window.lytesLimits = true;

  const SETTLE_MS = 2500;
  const ADD_BUTTONS = 'add-to-cart-component button, [data-type="add-to-cart-form"] button[type="submit"], .quick-add__button--add';
  let known = {};
  let toast;

  const totals = (cart) => {
    const out = {};
    for (const item of cart.items || []) {
      out[item.variant_id] = out[item.variant_id] || { qty: 0, title: item.product_title };
      out[item.variant_id].qty += item.quantity;
    }
    return out;
  };
  const refresh = () =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => (known = totals(cart)));

  const show = (title, held) => {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lytes-limit-toast';
      toast.setAttribute('popover', 'manual');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    const what = held > 0 ? `so your cart now has ${held}.` : 'and your cart already has the most we can sell in one order.';
    toast.innerHTML =
      `<p class="lytes-limit-toast__text"><strong>Limit reached.</strong> There's a per-order limit on ${title}, ${what} ` +
      'Need more? <a href="/pages/contact">Contact us</a>.</p>' +
      '<button type="button" class="lytes-limit-toast__close" aria-label="Close">&times;</button>';
    toast.querySelector('button').addEventListener('click', () => toast.hidePopover());
    // Re-showing puts it on top of anything that entered the top layer since (the cart drawer)
    if (toast.matches(':popover-open')) toast.hidePopover();
    toast.showPopover();
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => toast.matches(':popover-open') && toast.hidePopover(), 9000);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest && event.target.closest(ADD_BUTTONS);
      if (!button) return;
      const form = button.closest('form') || button.closest('product-form-component')?.querySelector('form');
      const id = Number(form?.querySelector('[name="id"]')?.value);
      if (!id) return;
      const qtyInput = form.querySelector('[name="quantity"]') || (form.id && document.querySelector(`[name="quantity"][form="${form.id}"]`));
      const qty = Math.max(1, Number(qtyInput?.value) || 1);
      const had = known[id] ? known[id].qty : 0;
      setTimeout(async () => {
        try {
          await refresh();
          const now = known[id] ? known[id].qty : 0;
          if (now < had + qty && (known[id] || had)) show((known[id] || {}).title || 'this item', now);
        } catch (e) {}
      }, SETTLE_MS);
    },
    true
  );

  // Quantity changes and removals in the cart drawer or cart page: re-read so the next comparison is fair
  let pending;
  const later = (event) => {
    if (!event.target.closest || !event.target.closest('#cart-drawer, cart-items-component, .cart-items')) return;
    clearTimeout(pending);
    pending = setTimeout(() => refresh().catch(() => {}), 1500);
  };
  document.addEventListener('click', later, true);
  document.addEventListener('change', later, true);

  refresh().catch(() => {});
})();
